Date.prototype.yyyymmdd = function () {
  var dd = this.getDate()
  var mm = this.getMonth() + 1

  return [
    this.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
  ].join('-')
}
Date.prototype.ddmmyyyy = function () {
  var dd = this.getDate()
  var mm = this.getMonth() + 1

  return [
    (dd > 9 ? '' : '0') + dd,
    (mm > 9 ? '' : '0') + mm,
    this.getFullYear()
  ].join('-')
}

Date.prototype.hhmm = function () {
  var hh = this.getHours()
  var mm = this.getMinutes()
  var ampm = 'am';

  if(hh == 0)
  {
    hh = 12
    ampm = 'am'
  }
  else if(hh == 12) {
    ampm = 'pm'
  }
  else if(hh >= 13)
  {
    hh = hh - 12
    ampm = 'pm'
  }

  var time = [
    (hh > 9 ? '' : '0') + hh,
    (mm > 9 ? '' : '0') + mm
  ].join(':')

  return time + ' ' + ampm
}
